import React, { useEffect } from "react";
import PropTypes from "prop-types";

const toastStyles = {
  success: {
    container: "message-wrap success to-open_bets",
    defaultTitle: "Bet Matched",
  },
  error: {
    container: "message-wrap error to-open_bets",
    defaultTitle: "Bet Error",
  },
  warning: {
    container: "message-wrap warning to-open_bets",
    defaultTitle: "Warning",
  },
  info: {
    container: "message-wrap info to-open_bets",
    defaultTitle: "Info",
  },
};

const ToastSky = ({
  type = "success",
  title,
  message,
  sideType,
  selectionName,
  stake,
  odds,
  onClose,
}) => {
  const { container, defaultTitle } = toastStyles[type] || toastStyles.success;

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Overlay */}
      <div
        className="s-toast-overlay s-fixed s-top-0 s-left-0 s-w-full s-h-full"
        style={{ zIndex: 70 }}
        onClick={onClose}
      />

      {/* Toast */}
      <div id="msgBox" className={container} style={{ zIndex: 80 }}>
        <div className="message">
          <h4 id="header">{title || defaultTitle}</h4>
          <p id="info">
            {sideType && (
              <span id="sideType" className={sideType.toLowerCase()}>
                {sideType}
              </span>
            )}
            {selectionName && (
              <strong id="selectionName">{selectionName}</strong>
            )}{" "}
            {stake && (
              <>
                <strong id="stake">{stake}</strong> at odds{" "}
              </>
            )}
            {odds && <strong id="odds">{odds}</strong>}
            {message && <span className="ml-1">{message}</span>}
          </p>
        </div>
        <a
          id="close"
          className="close ui-link"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClose?.();
          }}
        >
          Close
        </a>
      </div>
    </>
  );
};

ToastSky.propTypes = {
  type: PropTypes.oneOf(["error", "warning", "success", "info"]),
  title: PropTypes.string,
  message: PropTypes.string,
  sideType: PropTypes.string,
  selectionName: PropTypes.string,
  stake: PropTypes.string,
  odds: PropTypes.string,
  onClose: PropTypes.func,
};

export default ToastSky;
